import React, { useState } from "react";
import { Button, Upload, List, message } from "antd";
import { UploadOutlined, DeleteOutlined, EyeOutlined } from "@ant-design/icons";
import axios from "../util/axiosConfig";
import { useInvContext } from "../context/InvContext";
import '../styles/upload.css'

interface FileData {
    fileDetailId: string | null;
    name: string;
    s3Url: string | null;
}

interface VendorDocProps {
    accessToken: any;
}

const UploadVendor: React.FC<VendorDocProps> = ({ accessToken }) => {
    const { vendorDoc } = useInvContext();
    const [files, setFiles] = useState<FileData[]>([]);

    const handleFileUpload = async (file: File) => {
        const formData = new FormData();
        formData.append("file", file);

        try {
            const response = await axios.post("/vendor-attachment-upload", formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                    Authorization: `Bearer ${accessToken}`,
                },
            });

            const fileData = response.data.data[0];
            const uploadedFile = {
                fileDetailId: fileData.fileDetailId,
                name: file.name,
                s3Url: fileData.s3Url
            };

            // Add uploaded file to state and vendorDoc context
            setFiles((prevFiles) => [...prevFiles, uploadedFile]);
            vendorDoc.push({
                fileDetailId: fileData.fileDetailId,
            });
            message.success(`${file.name} uploaded successfully.`);
            console.log(vendorDoc);
        } catch (error) {
            console.error("File upload failed:", error);
            message.error(`File upload failed: ${file.name}`);
        }
    };

    const handleRemove = (fileDetailId: string | null) => {
        setFiles((prevFiles) => prevFiles.filter((file) => file.fileDetailId !== fileDetailId));
        const updatedVendorDoc = vendorDoc.filter((doc) => doc.fileDetailId !== fileDetailId);
        vendorDoc.length = 0;
        vendorDoc.push(...updatedVendorDoc);
        console.log(vendorDoc);
        message.success("File removed successfully.");
    };

    const handleView = (fileDetailId: string | null) => {
        const currentFile = files?.filter((file: any) => file.fileDetailId === fileDetailId);
        const currentURL = currentFile[0].s3Url
        if (currentURL) {
            window.open(currentURL, '_blank');
        }

    }

    const handleBeforeUpload = (file: File) => {
        handleFileUpload(file);
        return false; // Prevent auto upload by Ant Design Upload component
    };

    return (
        <div className="vendorUploadContainer">
            <h3>Upload Documents</h3>

            <Upload
                multiple
                beforeUpload={handleBeforeUpload}
                accept=".jpg,.jpeg,.png,.pdf,.doc,.docx"
                showUploadList={false}
            >
                <Button icon={<UploadOutlined />}>Click to Upload</Button>
            </Upload>
            <br />
            <List
                bordered
                dataSource={files}
                renderItem={(file) => (
                    <List.Item
                        actions={[
                            <Button
                                type="text"
                                icon={<DeleteOutlined />}
                                danger
                                onClick={() => handleRemove(file.fileDetailId)}
                            >
                                Remove
                            </Button>,
                            <Button
                                type="text"
                                icon={<EyeOutlined />}
                                danger
                                onClick={() => handleView(file.fileDetailId)}
                            >
                                View
                            </Button>,
                        ]}
                    >
                        {file.name}
                    </List.Item>
                )}
            />
        </div>
    );
};

export default UploadVendor;
